import React, { useEffect, useRef, useState } from "react"

import { useDispatch, useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import { faFileAlt, faPlus } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast } from "react-toastify"

import { apiRoute, ENUM_CURRENCY_SETTING_VAL, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_USERSETING_PARAMS, ENUM_USERSETING_SETVALUE, FixHeight, FixMobileHeight, FixScreenHeight, GetLoginCredentialDb, getModValue, linksUrl } from "../constants/enum.js"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,

} from "../components/index.js"
import { useFetchWithBody, usePost, usePostLogin, usePostMutateWithSuccess } from "../api/reactQueryCustomHooks.jsx"
import { resetCompCode, setAppType, setCompCode, setCompInfo, setCurrencyType, setReload, setSalePerson } from "../state/companySlice.jsx"
import { COLUMN_ALIGN_TYPE, TOP_ACTION_BTN_TYPE } from "../components/NextUITable.jsx"
import { addToast, Button, Card, CardBody } from "@heroui/react"
import { setLogout } from "../state/authSlice.jsx"
import { useQueryClient } from "@tanstack/react-query"
import { isMobile } from "react-device-detect"
import { setDetailParams, setNewEntryMode } from "../state/orderSlice.jsx"

const Companies = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { yearId, compCode } = useSelector((state) => state.company)
  const { user } = useSelector((state) => state.auth)
  const queryClient = useQueryClient()
  const [compData, setCompData] = useState([])
  // const { data: userCompMapData = [], } = useFetchWithBody({
  //   url: apiRoute.userCompMaping.getUserMaping,
  //   queryKey: "getUsermaping",
  //   inputData: {
  //     userid: user.username
  //   },
  // })
  const { mutate: funGetUserCompMap } = usePostMutateWithSuccess({
    url: apiRoute.userCompMaping.getUserMaping,
    queryKey: "getUsermaping",

  })
  //console.log(userCompMapData)
  const {
    isPending,
    isError,
    data = [],
    mutate: funSetYearId
  } = usePost({
    url: apiRoute.setAcYearId,
    queryKey: "Company",
    onSuccessTasks: (data) => {
      const mainCompData = data
      
      if (mainCompData && mainCompData.length > 0) {

        funGetUserCompMap({
          data: {
            userid: user.username,
          },
          onSuccess: (data) => {
            const userData = data

            if (userData && userData.length > 0) {
              const selComp = userData.map(ele => String(ele.COMPCODE));
              let filterData = mainCompData.filter((ele) => selComp.includes(String(ele.COMPCODE)))

              setCompData(filterData[0])
              setcomInfo([filterData[0]])
              fun_setUseBroMap(filterData[0])

            }
            else {

              setCompData(mainCompData[0])
              setcomInfo([mainCompData[0]])
              fun_setUseBroMap(mainCompData[0])
            }
          }
        })
      }
      else
        setCompCode([])


    }



  })

  // const
  const setcomInfo = (selData) => {

    //const selData = compData
    // const salePerson = userCompMapData.filter(ele => ele.CompCode == selData[0].COMPCODE).map(item => item.SalePer_Name);
    // console.log(salePerson, "srtert", selData[0])
    dispatch(setCompCode({ compCode: [selData[0].COMPCODE], compName: [selData[0].COMPNAME] }))
    dispatch(setCompInfo({
      yearId: selData[0]?.YEAR_ID, startDate: selData[0]?.SDATE, endDate: selData[0]?.EDATE,
      state: selData[0]?.STATE, groupCode: selData[0].CGCODE
      , address: selData[0]?.COMP_ADDRESS
      , panNo: selData[0]?.IT_NO
      , objComp: selData
      , gstNo: selData[0]?.Gst_No
      //, salePerson: salePerson
      //,objYear:[]]
    }))

  }


  // const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
  //   url: apiRoute.modSetting.getModSetting,
  //   queryKey: "fetchModSettingCurrency",
  //   inputData: {
  //     mod_name: ENUM_MOD_NAME.GeneralSettings
  //   }
  // })
  const fun_setUseBroMap = (selData) => {

    funGetUserBroMap({
      data: {
        userid: user.username,
        compcode: selData.COMPCODE
      },
      onSuccess: (data) => {

        if (data && data.length > 0)
          dispatch(setSalePerson(data))
        else {
          if (!toast.isActive("toastsmap")) {
            toast.error("Sale Person Maping Not Found  !", {
              "position": "top-center",
              // className: "toast-error"
              toastId: "toastsmap",
              onClose: () => {
                dispatch(setLogout())
                dispatch(resetCompCode())
                navigate(linksUrl.login)
              }
            })

          }
        }
      }
    })
  }

  const { data: salePersonData = [], mutate: funGetUserBroMap } = usePostMutateWithSuccess({
    url: apiRoute.userCompMaping.getUserBrokerMaping,
    queryKey: "getUsermaping",

  })

  // useEffect(() => {
  //   let CurrencyType = getModValue(ENUM_MOD_PARAMETER.GeneralSetting.CurrencyType, modSetting)
  //   dispatch(setCurrencyType(CurrencyType ?? ""))
  // }, [modSetting])

  useEffect(() => {
    funSetYearId({
      data: {
        ac_year: yearId,
        comp_code: ''
      }
    })
  }, [])

  const handleNewOrder = () => {
    dispatch(setNewEntryMode(true));
    dispatch(setDetailParams([]));
    navigate(linksUrl.salesOrder.createEntry);
  }

  //const INITIAL_VISIBLE_COLUMNS = ["COMPNAME"]

  // const columns = [{ name: "COMPNAME", uid: "COMPNAME", sortable: true, align: COLUMN_ALIGN_TYPE.left }]

  // const topActionBtn = [
  //   {
  //     label: "Connect",
  //     icon: <FontAwesomeIcon icon={faPlus} />,
  //     isShowOnSelection: true,
  //     type: TOP_ACTION_BTN_TYPE.link,
  //     onClick: ({ selectedKeys }) => {
  //       let selectedCompCode = []
  //       let selectedCompName = []
  //       if (selectedKeys !== "all") {
  //         selectedKeys.forEach((value) => {
  //           selectedCompCode.push(value)
  //           //get selected compname
  //           let filterData = compData.filter((ele) => ele.COMPCODE == value)
  //           if (filterData && filterData.length > 0) selectedCompName.push(filterData[0].COMPNAME)
  //         })
  //       } else {
  //         compData.map((item) => selectedCompCode.push(item.COMPCODE))
  //       }
  //       toast.success("Conntected", {
  //         position: "top-center",
  //         autoClose: 1000,
  //       })

  //       //get selected company name 
  //       const intSelCompCode = selectedCompCode.map(value => parseInt(value, 10));
  //       const selData = compData.filter((ele) => intSelCompCode.includes(ele.COMPCODE))
  //       console.log(selData)
  //       dispatch(setCompCode({ compCode: selectedCompCode, compName: selectedCompName }))
  //       dispatch(setCompInfo({
  //         yearId: selData[0]?.YEAR_ID, startDate: selData[0]?.SDATE, endDate: selData[0]?.EDATE,
  //         state: selData[0]?.STATE, groupCode: selData[0].CGCODE
  //         , address: selData[0]?.COMP_ADDRESS
  //         , panNo: selData[0]?.IT_NO
  //         , objComp: selData
  //         ,gstNo:selData[0]?.Gst_No
  //         //,objYear:[]]
  //       }))

  //       let startup_page = linksUrl.dashboard

  //       navigate(startup_page)
  //     },
  //   },
  // ]

  if (isPending) {
    return <LoadingCard />
  }
  const handleOnclick = () => {
    dispatch(setLogout())
    dispatch(resetCompCode())
    queryClient.removeQueries()
    navigate(linksUrl.login)
  }
  if (isError) {
    return <ErrorCard />
  }

  return (
    <div>
      
      <MainContainer pageName={"Home"}
        breadcrumbs={[]}>
        <Card>
          <CardBody className=""
            style={{ height: isMobile ? FixMobileHeight : FixScreenHeight }}
          >
            {/* <MyComponent items={items}  /> */}
            <div className="mx-auto">
              <Button size="md" radius="none" color="success" variant={"flat"} onPress={handleNewOrder}
                className=" border-0 text-sm w-full font-semibold bg-gradient-to-t from-slate-600 to-slate-500  text-white"
                startContent={<FontAwesomeIcon className="text-md" icon={faFileAlt} />}>New Order</Button>
            </div>
          </CardBody>
        </Card>
        {/* {isError ? <div className="bg-yellow-200 px-6 py-4 my-4 text-amber-700 rounded-md text-md flex gap-4  items-center mx-auto max-w-lg">Something went wrong !
          <Button onPress={handleOnclick()} variant="light" style={{ color: "#eb8b0e" }} className="text-sm text-Rose-700" >Click here to Reconnect</Button> </div> :
          <NextUITable
            INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
            data={compData}
            columns={columns}
            exportColumns={columns}
            topActionBtn={topActionBtn}
            downloadFileName="Company"
            showAdvanceFilter={false}
            id="COMPCODE"
            rowSelection={true}

          />
        } */}
      </MainContainer>

    </div>
  )
}

export default Companies
